import { render, staticRenderFns } from "./fooder.vue?vue&type=template&id=67700ef2&scoped=true"
import script from "./fooder.vue?vue&type=script&lang=js"
export * from "./fooder.vue?vue&type=script&lang=js"
import style0 from "./fooder.vue?vue&type=style&index=0&id=67700ef2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67700ef2",
  null
  
)

export default component.exports